export enum PARTNER_STATUS {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export enum PARTNER_GROUP {
  PARTNER = 'PARTNER',
  AFFILIATE = 'AFFILIATE',
}

export enum PARTNER_ACTION {
  EDIT = 'edit',
  DELETE = 'delete',
}

export enum PARTNER_ERROR_CODE {
  SLUG_ALREADY_IN_USE = 'PARTNER_SLUG_ALREADY_IN_USE',
  HAS_ORGANIZATIONS = 'PARTNER_HAS_ORGANIZATIONS',
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
  PARTNER_DISABLED = 'PARTNER_DISABLED',
}

export interface Partner {
  id: string;
  slug: string;
  display_name: string;
  tenant_id: string;
  tenant_slug: string;
  logo?: string;
  status: PARTNER_STATUS;
  partner_group: PARTNER_GROUP;
  contact_name?: string;
  contact_email?: string;
  impersonation_enabled: boolean;
  created_at: string;
  updated_at: string;
}

/** Also creates the partner's first admin, who signs in with `email` and `password`. */
export interface PartnerCreateRequest {
  slug: string;
  display_name: string;
  email: string;
  password: string;
  logo?: string;
  partner_group: PARTNER_GROUP;
  contact_name?: string;
  contact_email?: string;
  impersonation_enabled: boolean;
}

/** Fields left out stay unchanged; `null` removes the logo or a contact field. */
export interface PartnerPatchRequest {
  display_name?: string;
  logo?: string | null;
  status?: PARTNER_STATUS;
  partner_group?: PARTNER_GROUP;
  contact_name?: string | null;
  contact_email?: string | null;
  impersonation_enabled?: boolean;
}
